
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import moment from "moment";
import { downloadExcel } from "react-export-table-to-excel";
import userService from "../../../../Services/apiService/user-service";
import ViewTransaction from "../../../../Component/transaction/viewTransaction";
import { useAuth } from "../../../../Utils/Auth";
import AccountService from "../../../../Services/AccountService";
import { customErrorHandler , toTitleCase} from "../../../../Utils/helper";
import FullScreenLoader from "../../../../Component/FullScreenLoader";
import FilterCard from "../../../../Component/filter_card";

const UserTransaction = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 10,
  });
  const [isLoading, setIsLoading] = useState(false);
  const filterInitialState = {
    transactionType: '',
    admin: '',
    searchedAdmin: [],
    introducer: '',
    searchedIntroducer: [],
    bank: '',
    searchedBank: [],
    website: '',
    searchedWebsite: [],
    minAmount: '',
    maxAmount: '',
    transactionId: '',
    startDate: new Date() - 1 * 24 * 60 * 60 * 1000,
    endDate: new Date(),
    adminSerachQuery: '',
    introducerSerachQuery: '',
    bankSerachQuery: '',
    websiteSerachQuery: '',
    serachQuery: ''
  }
  const [filter, setFilter] = useState(filterInitialState)
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const [itemPerPage, setItemPerPage] = useState(10)

  const auth = useAuth();


  const tableHeaders = [
    { label: "Date & Time", field: "createdAt" },
    { label: "Amount", field: "amount" },
    { label: "Charge Percentage", field: "chargePercentage" },
    { label: "Charge Amount", field: "chargeAmount" },
    { label: "Bank", field: "bankName" },
    { label: "Website", field: "websiteName" },
    { label: "Bonus", field: "bonus" },
    { label: "Bank Charges", field: "bankCharges" },
    { label: "Txn Id", field: "txnId" },
    { label: "Txn Type", field: "transactionType" },
    { label: "Gateway", field: "paymentMethod" },
    { label: "Entry by", field: "subAdminId" },
    { label: "User", field: "userName" },
    { label: "Introducer", field: "introducerUserName" },
    // { label: "Balance", field: "balance" },
    { label: "Remarks", field: "remarks" },
  ];

  const fetchStatement = async (page) => {
    try {
      const payload = {
        transactionType: filter?.transactionType || "",
        subAdminId: filter?.admin || "",
        startDate: moment(filter.startDate).toDate(),
        endDate: moment(filter.endDate).toDate(),
        maxAmount: Number(filter?.maxAmount) || "",
        minAmount: Number(filter?.minAmount) || "",
        transactionId: filter?.transactionId,
        introducerUserName: filter?.introducer,
        bankName: filter?.bank,
        websiteName: filter?.website,
        userId : id
      };
      setIsLoading(true);
      const res = await userService.userAllTransactionReport(
        auth.user,
        payload,
        page || paginationData.page,
        itemPerPage,
      );
      const data = res?.data?.data?.map((item) => ({
        ...item,
        createdAt: new Date(item.createdAt)
          .toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          })
          .replace(/am|pm/i, (match) => match.toUpperCase()),
        //For Future Use
        //   updatedAt: new Date(item.updatedAt).toLocaleString("en-IN", {
        //     timeZone: "Asia/Kolkata",
        //     day: "2-digit",
        //     month: "2-digit",
        //     year: "numeric",
        //     hour: "2-digit",
        //     minute: "2-digit",
        //     second: "2-digit",
        //     hour12: true,
        //   }),
      }));
      setData(data);
      if (res?.data?.pagination) {
        setPaginationData((state) => ({
          ...state,
          page: res?.data?.pagination?.page,
          totalPages: res.data?.pagination?.totalPages,
          totalItems: res.data?.pagination?.totalItems,
          limit: res.data?.pagination?.limit,
        }));
      }
    } catch (err) {
      toTitleCase(customErrorHandler(err.message, "Something went wrong"));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchStatement();
  }, [id, filter?.transactionType, filter?.admin, filter.startDate, filter.endDate, filter.introducer, filter.bank, filter.website , itemPerPage]);
  // id, auth, select, subAdmin, page

  const startIndex = Math.min((paginationData.page - 1) * paginationData.limit + 1);
  const endIndex = Math.min(paginationData.page * paginationData.limit, paginationData.totalItems);


  const pageHandler = (selectedPage) => {
    fetchStatement(selectedPage);
  };


  const handleDownloadExcel = () => {
    setIsLoading(true)
    const header = tableHeaders.map(header => header.label)
    const extractedData = data.map(row =>
      tableHeaders.map(header => row[header.field])
    ); const opt = auth.user?.userName;

    downloadExcel({
      fileName: `saveTableAsExcel - ${opt}`,
      sheet: "react-export-table-to-excel",
      tablePayload: {
        header,
        body: extractedData
      }
    });
    setIsLoading(false)
  }

  return (
    <React.Fragment>
      <FilterCard
        visibleFilters={{
          transactionType: true,
          subAdmin: true,
          introducer: true,
          bankName: true,
          websites: true,
          amountRange: true,
          transactionId: true,
          dateRange: true
        }}
        options={{
          transactionTypes: ["Deposit", "Withdraw"],
        }}
        onFilterChange={() => { }}
        onFilterApply={() => { }}
        onFilterReset={() => setFilter(filterInitialState)}
        state={filter}
        setState={setFilter}
        setDebouncedSearch={setDebouncedSearch}
        debouncedSearch={debouncedSearch}
        fetchData={fetchStatement}
        handleDownloadExcel={handleDownloadExcel}
        isExcelDownloadable={data.length > 0}
        setItemPerPage = {setItemPerPage}
      />

      <ViewTransaction
        headers={tableHeaders}
        data={data}
        // onDelete={onTransactionDelete}   // dont do delete from here previously
        onSort={() => { }}
        sortField={""}
        sortDirection={true}
        onSearch={""}
        page={paginationData.page}
        totalPage={paginationData.totalPages}
        startIndex={startIndex}
        endIndex={endIndex}
        totalData={paginationData.totalItems}
        onPageChange={pageHandler}
      />
      <FullScreenLoader show={isLoading} />
    </React.Fragment>
  );
};

export default UserTransaction;
